<template>
  <div>
    <table v-if="haveData" class="event-count-table">
      <thead>
        <tr>
          <th>Pid UID</th>
          <th>Date</th>
          <th>Event Count</th>
          <th>Journey Count</th>
          <th>Line Names</th>
          <th>Vehicle Refs</th>
        </tr>
      </thead>
      <tbody>
        <PidEventCountRow v-for="(piddata, index) in sortedPidData" :key="index" :piddata="piddata"
          @click="selectRow(piddata)" :class="{ selected: isSelected(piddata) }" />
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import PidEventCountRow from './PidEventCountRow.vue';

const dataStore = inject('datastore');

const haveData = computed(() => {
  return dataStore.pideventcounts.length > 0;
})

const sortedPidData = computed(() => {
  return [...dataStore.pideventcounts].sort((a, b) => {
    // Sort by Date descending
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;

    // Then by UID ascending (or string comparison)
    if (a.uid < b.uid) return -1;
    if (a.uid > b.uid) return 1;
    return 0;
  });
});

const selectRow = (piddata) => {
  const originalIndex = dataStore.pideventcounts.indexOf(piddata);
  dataStore.selectedRow = originalIndex;
}

const isSelected = (piddata) => {
  return dataStore.pideventcounts[dataStore.selectedRow] === piddata;
}

</script>

<style>
.event-count-table {
  width: 100%;
  /* Make the table take up 100% of the container width */
  table-layout: auto;
  /* Fix the layout of the table */
  border-collapse: collapse;
}

.event-count-table thead {
  background-color: #007bff;
  /* Set the background color of the header row */
  color: white;
  /* Optional: change the text color to contrast */
}

.event-count-table th,
.event-count-table td {
  border: 1px solid #ccc;
  padding: 0px 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}

.event-count-table th:nth-child(6),
/* Target the third column for the extra space */
.event-count-table td:nth-child(6) {
  width: 100%;
  /* Let this column take all the remaining space */
}
</style>

<style scoped>
.selected {
  background-color: #f0f0f0;
  /* Highlight color */
}
</style>